import { PROFILE_EVENTS } from '../../constants/events';
import { copyObject } from '../../utils';

let defaultState = {
  profileRichnessForm: {
    questions: [],
    answers: {},
    currentQuestion: 1,
    questionsLoaded: false,
    popupOpen: false,
    ackOpen: false,
    ackType: '',
    formSubmitted: false,
    config: {},
    submittedAnswers: []
  }
};

const profileReducer = (state = defaultState, actions) => {
  let newState;
  switch (actions.type) {
    case PROFILE_EVENTS.TOGGLE_POPUP:
      newState = copyObject(state);
      newState.profileRichnessForm.popupOpen = actions.payload;
      state = newState;
      break;
    case PROFILE_EVENTS.SET_QUESTION:
      newState = copyObject(state);
      newState.profileRichnessForm.currentQuestion = actions.payload;
      state = newState;
      break;
    case PROFILE_EVENTS.INITIALIZE_CONTEXT:
    case PROFILE_EVENTS.UPDATE_CONTEXT:
      newState = copyObject(state);
      newState.profileRichnessForm = Object.assign({}, state.profileRichnessForm, actions.payload);
      state = newState;
      break;
    case PROFILE_EVENTS.TOGGLE_ACK:
      newState = copyObject(state);
      newState.profileRichnessForm.ackOpen = actions.payload;
      state = newState;
      break;
    case PROFILE_EVENTS.FORM_SUBMITTED:
      newState = copyObject(state);
      newState.profileRichnessForm.formSubmitted = true;
      state = newState;
      break;
  }
  return state;
};

export default profileReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/ProfileReducer/index.js